import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  useTheme,
} from "@mui/material";
import IwButton from "../../../../components/app/IwButton";
import { useState } from "react";
import { usePostSkipZoomToggleInterviewSetupTip } from "../../../../tanstackQuery/social-integrations/handle-zoom";
import { useKeycloak } from "@react-keycloak/web";
import { baseAtom, setSkipZoomToggleInterviewSetupTip } from "../../../../stores/jotai/base";
import { useAtom } from "jotai";

const ZoomEventModal = (props) => {
  const theme = useTheme();
  const {keycloak} = useKeycloak()
  const [base, setBase] = useAtom(baseAtom);
  const [checked, setChecked] = useState(false);
  const {
    openZoomEventModal,
    setZoomEventModal,
    alertModalTitle,
    alertModalDescription,
    setAlertModalTitle,
    setAlertModalDescription,
    event,
    showSetupInterviewInfo,
    setShowSetupInterviewInfo,
  } = props;
  const { mutateAsync: skipZoomToggleInterviewSetupTip } =
    usePostSkipZoomToggleInterviewSetupTip(
      { accessToken: keycloak.token },
    );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleCloseZoomEventModal = async () => {
    if (!base.user?.userPreference?.skipZoomToggleInterviewSetupTip  && !event.appInterviewID) {
      if (checked) {
        const response = await skipZoomToggleInterviewSetupTip({
          userPreference: JSON.stringify({
            skipZoomToggleInterviewSetupTip: true,
          }),
        });
        if (response.isSuccess) {
          setSkipZoomToggleInterviewSetupTip(setBase, true);
        }
      }
      setShowSetupInterviewInfo(false);
    }
    setZoomEventModal(!openZoomEventModal);
    setAlertModalDescription("");
    setAlertModalTitle("");
    setChecked(false);
  };
  return (
    <Dialog
      sx={{ zIndex: theme?.custom?.dialogZIndex }}
      open={openZoomEventModal}
    >
      <Box>
        <DialogTitle>{alertModalTitle}</DialogTitle>
        <DialogContent>{alertModalDescription}</DialogContent>

        <Stack direction={"row"} justifyContent={"space-between"} m={2}>
          {
            showSetupInterviewInfo && 
            <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Don't show this again"
          />
          }
          <IwButton
            variant="contained"
            onClick={handleCloseZoomEventModal}
             sx={{ ml: "auto" }} 
          >
            ok
          </IwButton>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ZoomEventModal;
